import { render } from "./right-bar.vue?vue&type=template&id=6f6510b4"
import script from "./right-bar.vue?vue&type=script&lang=js"
export * from "./right-bar.vue?vue&type=script&lang=js"

import "./right-bar.vue?vue&type=style&index=0&id=6f6510b4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__